import $ from 'jquery';

function carouselNavigation() {
	var $carouselNavigationTrigger = $('.js-carousel-trigger');

	$carouselNavigationTrigger.on('click', function () {
		var $carouselNavigation = $(this).closest('.carousel-navigation');

		if ($carouselNavigation.length) {
			var scope = $carouselNavigation.data('scope'),
				$carousel = $('.js-entry-carousel');

			if (scope) {
				$carousel = $(this).closest(scope).find('.js-entry-carousel');
			}

			console.log($carousel.length);
			if ($carousel.length) {
				if ($(this).hasClass('carousel-navigation__arrow_type_prev')) {
					$carousel[0].swiper.slidePrev();
				}else {
					$carousel[0].swiper.slideNext();
				}
			}
		}

		return false;
	});
}

export default carouselNavigation;



// WEBPACK FOOTER //
// ./app/blocks/carousel-navigation/carousel-navigation.js